import { useQuery } from '@tanstack/vue-query';
import { queries } from '~/keys';
import { USER_ROLES } from '~/constants/auth';
import type { CoBrokeAccess } from '~/types/coBrokeAccess';

// Co-broke Nominated Broker access for the signed-in agent (ID-133); agents only.
export const useCoBrokeAccessQuery = () => {
  const authStore = useAuthStore();
  return useQuery({
    ...queries.coBrokeAccess.mine,
    queryFn: () =>
      $fetch<{ data: CoBrokeAccess }>('/api/agent/co-broke/access', {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }).then((r) => r.data),
    enabled: computed(() => !!authStore.token && authStore.user?.role === USER_ROLES.AGENT),
    staleTime: 60_000,
    retry: false,
    throwOnError: false,
  });
};
